import {Component, Input} from '@angular/core';

@Component({
    selector: 'ftl-client-profile',
    template: `
        <a *ngIf="id" [routerLink]="['/space/customers/profiles/registered', id]">{{ name }}</a>
        <span *ngIf="!id">{{ name }}</span>
    `
})
export class ClientProfileComponent {
    @Input('id') id: number;
    @Input('name') name: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/components/profile/client.profile.component.ts